export enum ErrorType {
  NOTFOUND = "NOTFOUND",
  FORBIDDEN = "FORBIDDEN",
  INTERNALERROR = "INTERNALERROR",
  UNAUTHORIZED = "UNAUTHORIZED",
}
